export default {
    URL_ACESSO: '/ExecucaoPregao/priv/sgc/pregao/InitPregaoEletronico.htm'
}
